// src/components/Admin/AdminWidgets.jsx
// Piezas visuales reutilizables entre tabs: gráficas ligeras en SVG (sin
// librerías) y tarjetas de KPI.
import React from 'react';

export const MiniBarChart = ({ data, color = '#9A0002', formatValue = (v) => v }) => {
  const max = Math.max(...data.map((d) => d.value), 1);
  return (
    <div className="flex items-end gap-3 h-40 pt-4">
      {data.map((d, i) => (
        <div key={i} className="flex-1 flex flex-col items-center gap-2">
          <span className="text-[11px] font-medium text-[#3A2A20]/60">{formatValue(d.value)}</span>
          <div
            className="w-full rounded-t-md transition-all"
            style={{
              height: `${Math.max((d.value / max) * 100, 3)}%`,
              backgroundColor: color,
              opacity: 0.55 + (d.value / max) * 0.45,
            }}
          />
          <span className="text-[11px] text-[#3A2A20]/50 uppercase tracking-wide">{d.label}</span>
        </div>
      ))}
    </div>
  );
};

const STATUS_META = {
  pending: { label: 'Pendientes', color: '#B08D57' },
  confirmed: { label: 'Confirmadas', color: '#3A6B4C' },
  'checked-in': { label: 'Check-in hecho', color: '#3A5A7A' },
  'checked-out': { label: 'Check-out hecho', color: '#3A2A20' },
  completed: { label: 'Completadas', color: '#6B4A7A' },
  cancelled: { label: 'Canceladas', color: '#9A0002' },
};

export const StatusBreakdown = ({ counts, total }) => (
  <div className="space-y-3">
    {Object.entries(STATUS_META).map(([key, meta]) => {
      const count = counts[key] || 0;
      const pct = total ? Math.round((count / total) * 100) : 0;
      return (
        <div key={key}>
          <div className="flex justify-between text-xs mb-1">
            <span className="text-[#3A2A20]/70">{meta.label}</span>
            <span className="text-[#3A2A20]/50">{count} · {pct}%</span>
          </div>
          <div className="h-2 rounded-full bg-[#3A2A20]/5 overflow-hidden">
            <div
              className="h-full rounded-full transition-all"
              style={{ width: `${pct}%`, backgroundColor: meta.color }}
            />
          </div>
        </div>
      );
    })}
  </div>
);

export const KpiCard = ({ label, value, sublabel, accent = false }) => (
  <div className={`rounded-2xl border p-5 ${accent ? 'bg-[#9A0002] border-[#9A0002]' : 'bg-white border-[#3A2A20]/10'}`}>
    <p className={`text-xs font-semibold uppercase tracking-wide ${accent ? 'text-[#EFE6DD]/70' : 'text-[#3A2A20]/50'}`}>
      {label}
    </p>
    <p className={`mt-2 font-['Fraunces'] text-3xl font-semibold ${accent ? 'text-[#EFE6DD]' : 'text-[#3A2A20]'}`}>
      {value}
    </p>
    {sublabel && (
      <p className={`mt-1 text-xs ${accent ? 'text-[#EFE6DD]/60' : 'text-[#3A2A20]/40'}`}>{sublabel}</p>
    )}
  </div>
);